import { FileText, MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateTwilioFlexCustomFieldsFillUpAr: TemplateAr = {
  name: 'أتمتة تعبئة حقول Twilio Flex المخصصة بالذكاء الاصطناعي',
  description:
    'عبّئ حقول Twilio Flex المخصصة تلقائياً أثناء المحادثة، وأعفِ فريق الدعم من الإدخال اليدوي.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'العميل' },
    { icon: Sparkles, label: 'الـ AI يستخرج' },
    { icon: FileText, label: 'الحقول معبّأة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'عبّي خصائص المهام في Twilio Flex وأنت في نص المحادثة، مو بعد ما تخلّص. الـ AI يقرأ الكلام لحظياً، ويطلع منه نقاط البيانات الأساسية، ويحدّث خصائص المهمة بنفسه.',
    paragraph2:
      'الـ AI يكتب بيانات الخصائص مباشرة في مهام Flex عندك، ويشتغل جنب سير عملك ومنطق التوجيه اللي مركّبه أصلاً في Flex. إعداداتك ما تتغير، والـ AI هو اللي يتأقلم معها.',
  },
  benefits: [
    'ما أحد يعبّي حقل بيده',
    'كل مهمة تطلع بخصائص معبّاة نفس الطريقة',
    'وقت معالجة المهمة ينزل وتلاحظ الفرق',
    'تقاريرك تطلع أدق',
    'كل تعبئة تنزل في سجل التدقيق، لأغراض الامتثال',
    'يشتغل مع كل خصائص Flex المخصصة عندك',
  ],
};
